<div class="contract-organisations-tab" data-testid="contract-organisations-tab">
    @if (!isActive) {
        <div class="alert alert-info" role="status" data-testid="contract-organisations-inactive">
            This contract is {{ contract?.deletedAt ? 'deleted' : 'deactivated' }}. Linked organisations are read-only.
        </div>
    }
    @if (loading) {
        <spinner></spinner>
    } @else {
        @if (loadError) {
            <div class="alert alert-warning" role="alert" data-testid="contract-organisations-error">{{ loadError }}</div>
        } @else if (rows.length === 0) {
            <p class="text-muted" data-testid="contract-organisations-empty">No organisations linked</p>
        } @else {
            <div class="table-responsive">
                <table class="table table-sm align-middle" data-testid="contract-organisations-table">
                    <caption class="visually-hidden">Organisations linked to this contract</caption>
                    <thead>
                        <tr>
                            <th scope="col">Name</th>
                            <th scope="col">Code</th>
                            <th scope="col">Address</th>
                            <th scope="col">City</th>
                            <th scope="col">Postcode</th>
                            @if (canWrite) {
                                <th scope="col">Actions</th>
                            }
                        </tr>
                    </thead>
                    <tbody>
                        @for (row of rows; track row.id) {
                            <tr data-testid="contract-organisation-row">
                                <td>
                                    @if (canViewOrganisation) {
                                        <a [routerLink]="organisationLink(row)" data-testid="contract-organisation-link">{{ row.name }}</a>
                                    } @else {
                                        <span data-testid="contract-organisation-name">{{ row.name }}</span>
                                    }
                                    @if (organisationStatus(row)) {
                                        <span class="badge ms-2" [class.badge-deleted]="organisationStatus(row) === 'Deleted'" [class.badge-deactivated]="organisationStatus(row) === 'Deactivated'" data-testid="contract-organisation-status">{{ organisationStatus(row) }}</span>
                                    }
                                </td>
                                <td>{{ row.code }}</td>
                                <td>{{ row.address }}</td>
                                <td>{{ row.city }}</td>
                                <td>{{ row.postcode }}</td>
                                @if (canWrite) {
                                    <td>
                                        <button type="button" class="btn btn-link link-danger p-0 align-baseline"
                                                [attr.aria-label]="'Unlink ' + (row.name ?? row.code)"
                                                [disabled]="removing"
                                                confirmHeader="Confirm the action"
                                                confirmModal="Are you sure you want to unlink the selected organisation from this contract?"
                                                confirmMessage=""
                                                confirmOk="Yes, proceed"
                                                confirmCancel="No, cancel"
                                                confirmOkClass="btn-outline-danger"
                                                confirmCancelClass="btn-gray text-dark"
                                                [confirmCancelFirst]="true"
                                                (confirmedClick)="unlink(row)"
                                                data-testid="contract-organisation-unlink">
                                            <i class="bi bi-x-lg" aria-hidden="true"></i>
                                        </button>
                                    </td>
                                }
                            </tr>
                        }
                    </tbody>
                </table>
            </div>
        }
        @if (canWrite) {
            <div class="contract-organisations-actions">
                <button type="button" class="btn btn-success" #linkButton
                        [disabled]="removing"
                        (click)="openLinkModal()"
                        data-testid="contract-organisations-link">
                    <i class="bi bi-link-45deg me-2" aria-hidden="true"></i>Link organisations
                </button>
            </div>
        }
    }
</div>
